import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import {Motion, spring} from 'react-motion';
import {Transition} from 'react-transition-group';
import './animations.css';

class AnimationImage extends Component {
  constructor(props) {
		super(props);
		this.state = {
      inView: false,
      widthElement: 0,
    };
    this.onScroll = this.onScroll.bind(this);
  }
  isVisible = (ref) => {
    if(ref){
      const topPart = ReactDOM.findDOMNode(ref).getBoundingClientRect().top;
      const bottomPart = ReactDOM.findDOMNode(ref).getBoundingClientRect().bottom;
      
      const winHeight = window.innerHeight;
      if ((bottomPart < window.scrollY + winHeight) && (topPart > 0 && topPart < winHeight)) {
        this.setState({
          inView: true
        });
      }   
    }
  }

  onScroll = (event) => {
    this.isVisible(this.refs.vendor);
  }

  componentDidMount() {
    window.addEventListener('scroll', (event) => this.onScroll(event));
  }

  render() {
    const { src, altText, widthImage, animation } = this.props;
    //x: spring(this.state.inView ? 0 : (widthElement * ((direction === 'left') ? 1 : -1 ))),
    // console.log(animation);
    return(
      <Motion ref="vendor" style={{
        opacity: spring(this.state.inView ? 1 : 0),
      }}>
        {({ opacity }) =>
          {
            const transitionStyles = {
              entering: { 
                opacity: 1,
                animation:  `${animation.direction} ${animation.duration}ms ${animation.type}`, 
              },
              entered:  {
                opacity: 1
               },
            }
            
            return(
              <Transition in={this.state.inView} timeout={animation.duration}>
                  {(state) => {
                    const defaultStyle = {opacity: `${opacity}`};// {opacity: `${opacity}`};        
                    return(
                    <div style={{...defaultStyle,
                      ...transitionStyles[state],
                    }} >
                      <Image src={src} alt={altText} style={{width: widthImage, height:'100%'}} />
                    </div>
                  )}}
                </Transition>
            
            )}
       }
      </Motion>
    )
  }
}

// /
// const transitionStyles = {
//   entering: { 
//     opacity: 1,
//     animation: `moveFromRight ${duration}ms ease both`, 
//   },
//   entered:  {
//     opacity: 1
//    },
// };

const Image = styled.img`
  display: block;
  height: auto;
  backface-visibility: hidden;
`;


AnimationImage.propTypes = {
  src: PropTypes.string,
  altText: PropTypes.string,
  widthImage: PropTypes.string,
  position: PropTypes.string,
  align: PropTypes.string,
  animation: PropTypes.object
};

AnimationImage.defaultProps = {
  animation: { direction: 'fade', show: true, duration: 1000, type: 'ease both' }
}
export default AnimationImage;



// WEBPACK FOOTER //
// ./src/contents/editorPreview/layout/components/Layout/animation/AnimationImage.js